<template>
  <div class="product-item-price-tips" ref="popoverWrap" @mouseenter="onShow" @mouseleave="onHide">
    <transition name="fade-in-linear">
      <div
        class="price-tips-body"
        v-if="!hide && isHover"
        v-fixed-scroll
        :style="{width: `${bodyWidth}px`, right: `${right}px`, bottom: `${bottom}px`}"
      >
        <div class="tips-title">服务包含</div>
        <div class="tips-body" ref="tipsBody">{{product.service_content}}</div>
        <div class="arrow" :style="{right: `${this.contentWidth / 2 + 10}px`}"></div>
      </div>
    </transition>
    
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    product: Object,
    hide: Boolean,
  },
  data() {
    return {
      isHover: false,
      contentWidth: 0,
      bodyWidth: 0,
      timeoutId: null,
      right: 0, 
      bottom: 0,
    };
  },
  
  computed: {},
  created() {
    
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.contentWidth = this.$refs.popoverWrap.offsetWidth;

      // 计算文字占用宽度，动态设置
      const el = document.createElement('div');
      el.innerHTML = this.product.service_content;
      el.style = 'display:inline-block;font-size: 12px;line-height: 17px;white-space: pre-wrap;word-break: break-all;max-width: 340px;position:absolute;left:-999999px;padding:0 12px;';
      document.body.appendChild(el);
      this.bodyWidth = el.offsetWidth + 2;
      document.body.removeChild(el);
      // this.onShow();
    },
    onShow() {
      clearTimeout(this.timeoutId);
      this.timeoutId = setTimeout(() => {
        try {
          this.isHover = true; // 延迟 1 秒后显示 tooltip
          const rect = this.$refs.popoverWrap.getBoundingClientRect();
          console.log(rect);
          this.right = document.documentElement.clientWidth - rect.right - 10;
          this.bottom = document.documentElement.clientHeight - rect.top;
          console.log(this.right, this.bottom);
        } catch (error) {
          console.log(error);
        }
      }, 500); // 1 秒延迟
    },
    onHide() {
      clearTimeout(this.timeoutId);
      this.isHover = false;
    },
  },
};
</script>

<style lang="less" scoped>
.product-item-price-tips{
  position: relative;
  .price-tips-body{
    position: fixed;
    right: -10px;
    bottom: 100%;
    margin-bottom: 10px;
    box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
    background: #fff;
    margin-top: 38px;
    border-radius: 4px;
    max-width: 340px;
    padding: 6px 12px;
    box-shadow: 0px -6px 20px -2px rgba(47,51,61,0.18);
    display: inline-flex;
    flex-direction: column;
    align-items: flex-start;
    min-width: 82px;
    z-index: 150;
    .arrow{
      content: "";
      position: absolute;
      right: 20px;
      top: 100%;
      z-index: 5;
      transform: translateX(50%);
      border-width: 5px;
      border-style: solid;
      border-color: #fff;
      border-left-color: transparent !important;
      border-right-color: transparent !important;
      border-bottom-width: 0;
    }
    .tips-title{
      font-size: 14px;
      font-weight: 600;
      color: #2F333D;
      line-height: 20px;
    }
    .tips-body{
      color: #6F6F6F;
      margin-top: 4px;
      font-size: 12px;
      line-height: 17px;
      white-space: pre-wrap;
      word-break: break-all;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/country/components/product-item-price-tips.vue